import { Component, OnInit, Inject } from '@angular/core';
import { Testing } from 'src/app/features/requets/shared/model/testing.model';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-select-testing-dialog',
  templateUrl: './select-testing-dialog.component.html',
  styleUrls: ['./select-testing-dialog.component.scss']
})
export class SelectTestingDialogComponent implements OnInit {

  displayedColumns = ['codigo', 'nombre', 'vigencia', 'puntajeminimo' ];
  selectedRowIndex = -1;
  SelectTesting: Testing;
  dataSource;


  tittle: String;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SelectTestingDialogComponent>)  {
    this.dataSource = new MatTableDataSource<Testing>(data.testing);
    this.dataSource.filterPredicate = (data1: Testing, filter: string) =>
    (data1.codigo.indexOf(filter) !== -1 || data1.nombre.toString().indexOf(filter) !== -1);

  }

  ngOnInit() {
  }

  applyFilter(filterValue: string) {


    this.dataSource.filter = filterValue.trim().toUpperCase();
  }

  close() {
    this.dialogRef.close(null);
  }

  highlight(row) {
    this.selectedRowIndex = row.idprueba;
    this.SelectTesting = row;
  }

  sendSelect() {
    const data = { index: this.data.index, test: this.SelectTesting };
    this.dialogRef.close(data);
  }

}
